import { render, staticRenderFns } from "./MyDay_Subpage.vue?vue&type=template&id=2a078807&"
import script from "./MyDay_Subpage.vue?vue&type=script&lang=js&"
export * from "./MyDay_Subpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports